import React from 'react'

export const Test = ({text1,text2,text3,text4,title,image,link1text,link2text}) => {
    console.log(image)
  return (
    <>
    <section class="nft bannermm" style={{backgroundImage:`url(${image})`}}>
      <div class="container">
         <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="leftcont-ban">
                  <h1 class="montfont"><span>{text1} </span> <br/><strong>{text2}</strong> {text3}</h1>
                  <p>{text4}</p>
                  <a class="montfont poundbtn animbtnsstart popup-open" href="javascript:;" title="">{title}<i class="sprite btnarow"></i></a>
               </div>
            </div>
         </div>
      </div>
   </section>
   <section class="brdcrme">
      <div class="container">
         <div class="row">
            <div class="col-lg-12 col-md-12">
               <div class="content-incred">
                  <ul>
                     <li><a href="index-2.html">{link1text}</a></li>
                     <li><a href="javascript:;">{link2text}</a></li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </section>
    </>
  )
}
